/** Max length for personal profile phone (+ and digits). */
export const PROFILE_PHONE_MAX_LEN = 14;

/** Keep optional leading +, digits only; truncate to PROFILE_PHONE_MAX_LEN. */
export function sanitizeProfilePhone(value) {
  const raw = String(value ?? "");
  let out = "";
  for (const ch of raw) {
    if (ch >= "0" && ch <= "9") out += ch;
    else if (ch === "+" && out.length === 0) out += ch;
  }
  return out.slice(0, PROFILE_PHONE_MAX_LEN);
}
